/**
 * Created by lu on 2017/12/5.
 */
var nb = require('../nb');
module.exports = nb.define({
    view:{
        'class':['alert alert-dismissable',nb.bind('status'),nb.bind('visible')],
        $html:[{
            'class':'alert-text',
            $html:nb.bind('text')
        // },{
        //     tag:'button',
        //     type:'button',
        //     'class':'close',
        //     'data-dismiss':'alert',
        //     'aria-hidden':'true',
        //     $text:'x'
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/Alerts.js
// module id = 31
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32